import { Directive, ElementRef, HostListener, Renderer } from "@angular/core";


@Directive({
    selector : '[HoverGrid]'
})

export class HoverAnimation{
    constructor(private el: ElementRef, private renderer: Renderer){
    }

    @HostListener('mouseover') onMouseOver(){
       let icons = this.el.nativeElement.querySelector('.dash-icon01');
       this.renderer.setElementStyle(icons,'color', 'black');
    }
    @HostListener('mouseout') onMouseOut() {
        let icons = this.el.nativeElement.querySelector('.dash-icon01');
        this.renderer.setElementStyle(icons,'color', 'white');
     }
}